@if (formStep) {
  <wl-progressive-form-step-wrapper
    [rendering]="rendering"
    [title]="content.title.value"
    [stepName]="formStep?.stepId"
    [submitButtonText]="content.genericFields?.submitButtonText.value"
    submitButtonIcon="arrow-down"
    [submitButtonAutomationId]="submitButtonAutomationId"
    [progressiveFormSelectorKey]="progressiveFormSelectorKey"
    [formState]="formStep?.formState"
    [showWhenFutureStep]="false"
    [showSubmitButton]="false"
    [showSeperator]="false"
    [isReadonly]="isReadonly"
  >
    <ng-template wlProgressiveFormBody>
      @if (formStep?.hasGenericError) {
        <wl-error-card
          [mode]="'content'"
          [message]="content.genericFields?.errorMessage"
        ></wl-error-card>
      }
      <div class="d-flex flex-column flex-md-row">
        @for (questionOption of questionOptions; track questionOption) {
          <wl-progressive-form-value-progress-button
            class="me-1 mt-2 w-100"
            [rendering]="rendering"
            [buttonText]="questionOption.label"
            [value]="questionOption.value"
            [control]="formStep?.formState?.controls?.field"
            [progressiveFormSelectorKey]="progressiveFormSelectorKey"
            [stepId]="formStep?.stepId"
          ></wl-progressive-form-value-progress-button>
        }
      </div>
      <wl-more-info-button
        [explanation]="content.explanation"
        [rendering]="rendering"
        (giveMoreInfo)="giveMoreInfo.emit(content?.explanation)"
      ></wl-more-info-button>
    </ng-template>

    <ng-template wlProgressiveFormSummary>
      <div class="w-100">
        {{
          translateRadioOption(
            formStep?.formState?.value?.field,
            questionOptions
          )
        }}
      </div>
    </ng-template>
  </wl-progressive-form-step-wrapper>
}
